import classNames from 'class-names';
import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';

import Icon from '../../../Atoms/Icon/Icon';

import Content from './Content';
import styles from './wan.module.css';

const connectionStatusStyle = {
  online: 'text-success',
  offline: 'text-gray',
  unknown: 'text-secondary',
};

const ntzStatus = {
  txenabled: 'text-success',
  txdisabled: 'text-success',
  ignore: 'text-danger',
};

const antennaStatus = {
  txenabled: 'text-success',
  error: 'text-danger',
};

const icons = {
  antennaState: 'antenna-outline',
  beam: 'beam',
  satellite: 'satellite-outline',
  snr: 'terminal-outline',
  zoneState: 'transmission',
};

const VSat = ({
  connectionStatus,
  antennaState,
  beam,
  satellite,
  snr,
  zoneState,
}) => {
  return (
    <Row>
      <Col xs={6} xl>
        <Content
          icon={
            <Icon className={styles.iconMd} role="status" name={icons.snr} />
          }
          line1={`SNR${snr ? `: ${snr}dB` : ''}`}
          line2={connectionStatus || '---'}
          line2ClassName={classNames(
            'text-uppercase',
            connectionStatus
              ? connectionStatusStyle[connectionStatus.toLowerCase()] ||
                  'text-secondary'
              : 'text-gray-500',
          )}
        />
      </Col>

      <Col xs={6} xl>
        <Content
          icon={
            <Icon
              className={styles.iconMd}
              role="status"
              name={icons.zoneState}
            />
          }
          line1="No-Transmit Zones"
          line2={zoneState || '---'}
          line2ClassName={classNames(
            'text-uppercase',
            zoneState
              ? ntzStatus[zoneState.toLowerCase()] || 'text-secondary'
              : 'text-gray-500',
          )}
        />
      </Col>

      <Col xs={6} xl>
        <Content
          icon={
            <Icon
              className={styles.iconMd}
              role="status"
              name={icons.antennaState}
            />
          }
          line1="Antenna"
          line2={antennaState || '---'}
          line2ClassName={classNames(
            'text-uppercase',
            antennaState
              ? antennaStatus[antennaState.toLowerCase()] || 'text-blue-dark'
              : 'text-gray-500',
          )}
        />
      </Col>

      <Col xs={6} xl>
        <Content
          icon={
            <Icon
              className={styles.iconMd}
              role="status"
              name={icons.satellite}
            />
          }
          line1="Satellite"
          line2={satellite || '---'}
          line2ClassName={classNames({
            'text-gray-500': !satellite,
            'text-blue-dark': satellite,
          })}
        />
      </Col>

      <Col xl>
        <Content
          icon={
            <Icon className={styles.iconMd} name={icons.beam} role="status" />
          }
          line1="Beam"
          line2={beam || '---'}
          line2ClassName={classNames('text-uppercase', {
            'text-gray-500': !beam,
            'text-blue-dark': beam,
          })}
        />
      </Col>
    </Row>
  );
};

VSat.propTypes = {
  connectionStatus: PropTypes.string,
  antennaState: PropTypes.string,
  beam: PropTypes.string,
  satellite: PropTypes.string,
  snr: PropTypes.number,
  zoneState: PropTypes.string,
};

export default VSat;
